import { render, staticRenderFns } from "./UserEPwd_User_TransactionSetting.vue?vue&type=template&id=7fe7de1e"
import script from "./UserEPwd_User_TransactionSetting.vue?vue&type=script&lang=js"
export * from "./UserEPwd_User_TransactionSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports